import React from 'react';
import { ColorStatus } from '../../types';
import './DataCard.css';

interface DataCardProps {
  value: string | number;
  colorStatus: ColorStatus;
  /** When set, replaces status-based styling with this single color */
  customColor?: string;
  units?: string;
  label?: string;
  statusLabel?: string;
}

export const DataCard: React.FC<DataCardProps> = ({
  value,
  colorStatus,
  customColor,
  units,
  label,
  statusLabel
}) => {
  const formatNumber = (num: number): string => {
    // Add comma separators for big numbers
    const addCommas = (numStr: string): string => {
      return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    
    // Only show decimals if the number has meaningful decimal places
    if (num % 1 === 0) {
      return addCommas(num.toString()); // No decimals for whole numbers
    }
    return addCommas(num.toFixed(2)); // 2 decimals for decimal numbers
  };

  const getStatusText = () => {
    if (customColor) return 'Tracking';
    switch (colorStatus) {
      case 'green':
        return 'Looking great';
      case 'yellow':
        return 'Room to improve';
      case 'red':
        return 'Needs focus';
      default:
        return 'Tracking';
    }
  };

  return (
    <div
      className={`data-card ${customColor ? 'data-card--custom' : `data-card--${colorStatus}`}`}
      style={customColor ? ({ '--data-card-color': customColor } as React.CSSProperties) : undefined}
    >
      <div className="data-card__main">
        <div className="data-card__value">
          {typeof value === 'number' ? formatNumber(value) : value}{units ? ` ${units}` : ''}
        </div>
        {label && (
          <div className="data-card__label">
            {label}
          </div>
        )}
      </div>
      
      <div className="data-card__status">
        <span className="data-card__status-text">
          {statusLabel || getStatusText()}
        </span>
      </div>
    </div>
  );
};
